import { render, staticRenderFns } from "./pt-PT.vue?vue&type=template&id=5334364e&scoped=true&"
var script = {}
import style0 from "./pt-PT.vue?vue&type=style&index=0&id=5334364e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334364e",
  null
  
)

export default component.exports